import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang, loc } from "../i18n/LanguageContext";
import { useContent } from "../lib/useContent";
import { useSeo, Icon } from "../components/common";
import { PageHero } from "../components/PageHero";
import { CTABand } from "../components/blocks";
import { IMG } from "../data/site";

export default function FAQ() {
  const { t, lang } = useLang();
  useSeo("FAQ | Sparko Cleaning Netherlands", "Frequently asked questions about Sparko's premium cleaning services, quotes, scheduling and guarantees.");
  const { data: faqs } = useContent("faq");
  const [open, setOpen] = useState(0);

  return (
    <div>
      <PageHero title="Frequently Asked Questions" crumb={t.nav.faq} bg={IMG.office1}
        sub="Everything you need to know about working with Sparko." />

      <section className="mx-auto max-w-3xl px-5 md:px-8 py-24">
        <div className="space-y-3">
          {faqs.map((f, i) => (
            <div key={f.id} className="rounded-2xl border border-black/5 bg-white overflow-hidden" data-testid={`faq-item-${i}`}>
              <button onClick={() => setOpen(open === i ? -1 : i)} data-testid={`faq-btn-${i}`}
                className="w-full flex items-center justify-between gap-4 p-6 text-start">
                <span className="font-display text-lg text-navy">{loc(f, "q", lang)}</span>
                <span className={`grid place-items-center h-8 w-8 rounded-full bg-blue/10 text-blue shrink-0 transition-transform ${open === i ? "rotate-45" : ""}`}>
                  <Icon name="Plus" size={18} />
                </span>
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3 }}>
                    <p className="px-6 pb-6 text-slate-600 leading-relaxed">{loc(f, "a", lang)}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </section>

      <CTABand />
    </div>
  );
}
